import rawEventConfig from './eventConfig.json';

type EventConfig = {
  title: string;
  ogTitle: string;
  description: string;
  name: string;
  edition: string;
  weekday: string;
  displayDate: string;
  headerDate: string;
  year: number;
  isoDate: string;
  startTime: string;
  endTime: string;
  locationShort: string;
  locationFull: string;
  schemaLocationName: string;
  schemaAddress: string;
  ogImage: string;
  ogUrl: string;
};

const eventConfig = rawEventConfig as EventConfig;

export default eventConfig;

export const eventHeadline = `${eventConfig.edition} Veletrhu iKariéra v Brně se bude konat ve ${eventConfig.weekday} ${eventConfig.displayDate} ${eventConfig.year} od ${eventConfig.startTime}`;
